import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
import { blogArticles } from './homeData';
interface BlogSectionProps {
  onNavigate: (page: string) => void;
}
export function BlogSection({
  onNavigate
}: BlogSectionProps) {
  return <AnimatedSection className="py-8 sm:py-24 bg-white" data-id="element-16308">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16309">
        <div className="flex justify-between items-end mb-4 sm:mb-12" data-id="element-16310">
          <div data-id="element-16311">
            <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-1 sm:mb-3" data-id="element-16312">
              Полезные статьи
            </h2>
            <p className="text-xs sm:text-lg text-slate-500" data-id="element-16313">
              Блог об астрологии и самопознании
            </p>
          </div>
          <Button variant="ghost" className="hidden md:flex text-slate-500" onClick={() => onNavigate('blog')} data-id="element-16314">
            Все статьи <ArrowRight className="ml-2 w-4 h-4" data-id="element-16315" />
          </Button>
        </div>

        {/* Mobile: compact list */}
        <div className="sm:hidden space-y-2.5" data-id="element-16316">
          {blogArticles.map(article => <div key={article.id} className="flex gap-3 bg-white rounded-xl border border-slate-100 p-3 cursor-pointer" onClick={() => onNavigate('blog-post')} data-id="element-16317">
              <div className={`w-16 h-16 rounded-lg bg-gradient-to-br ${article.gradient} flex-shrink-0`} data-id="element-16318" />
              <div className="min-w-0" data-id="element-16319">
                <Badge variant="neutral" className="mb-1 bg-slate-50 text-slate-600 !text-[9px] !px-1.5 !py-0" data-id="element-16320">
                  {article.category}
                </Badge>
                <h3 className="text-xs font-bold text-slate-900 line-clamp-2" data-id="element-16321">
                  {article.title}
                </h3>
                <span className="text-[10px] text-slate-400" data-id="element-16322">
                  {article.readTime}
                </span>
              </div>
            </div>)}
        </div>

        {/* Desktop: grid */}
        <motion.div className="hidden sm:grid md:grid-cols-3 gap-8" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-16323">
          {blogArticles.map(article => <motion.div key={article.id} variants={staggerItem} data-id="element-16324">
              <Card hoverable padding="none" className="cursor-pointer group border-slate-100 h-full" onClick={() => onNavigate('blog-post')} data-id="element-16325">
                <div className={`h-44 bg-gradient-to-br ${article.gradient}`} data-id="element-16326" />
                <div className="p-6" data-id="element-16327">
                  <Badge variant="neutral" className="mb-3 bg-slate-50 text-slate-600" data-id="element-16328">
                    {article.category}
                  </Badge>
                  <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors line-clamp-2" data-id="element-16329">
                    {article.title}
                  </h3>
                  <p className="text-sm text-slate-500 mb-4 line-clamp-2" data-id="element-16330">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-slate-400 pt-4 border-t border-slate-100" data-id="element-16331">
                    <span data-id="element-16332">{article.date}</span>
                    <span className="flex items-center" data-id="element-16333">
                      <Clock className="w-3.5 h-3.5 mr-1" data-id="element-16334" /> {article.readTime}
                    </span>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}